import {DataGrid, enUS, trTR} from '@mui/x-data-grid';

import { useTranslation } from "react-i18next";

export default function LocalizedDataGrid(props) {

    const { i18n } = useTranslation();

    return <DataGrid 
        {...props} 
        localeText={
            i18n.resolvedLanguage === "en"? 
                enUS.components.MuiDataGrid.defaultProps.localeText
            :
                trTR.components.MuiDataGrid.defaultProps.localeText
        }
    />
}